<template>
  <li
    v-if="menuItemIsAvailable()"
    class="nav-item"
    :class="{'sidebar-group-active active': isActive}"
  >
    <b-link
      class="nav-link"
      :to="{ name: item.route }"
    >
      <feather-icon
        size="14"
        :icon="item.icon"
      />
      <span>{{ $t(item.title) }}</span>
    </b-link>
  </li>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import useHorizontalNavMenuHeaderLink
  from '@/core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-header-link/useHorizontalNavMenuHeaderLink'
import mixinHorizontalNavMenuHeaderLink
  from '@/core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-header-link/mixinHorizontalNavMenuHeaderLink'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BLink,
  },
  mixins: [mixinHorizontalNavMenuHeaderLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, updateIsActive } = useHorizontalNavMenuHeaderLink(props.item)
    const isArr = o => Array.isArray(o)
    return {
      isActive,
      updateIsActive,
      isArr,
    }
  },
  methods: {
    menuItemIsAvailable() {
      if (!this.menuItemIsAvailableByIntegratorModuleSettings()) {
        return false
      }
      return this.isArr(this.item.resource)
        ? this.item.resource.some(r => this.$can(this.item.action, r))
        : this.$can(this.item.action, this.item.resource)
    },
    menuItemIsAvailableByIntegratorModuleSettings() {
      const user = getUserData()
      if (user) {
        if (user.isRoot) {
          return true
        }
        return user.system_modules.includes(this.item.route)
      }
      return true
    }
  }
}
</script>
